module.exports = __webpack_public_path__ + "media/assets_v3/images/csgo-ranks/15-1caf45641343cf212c94d78ea6204a07.png";